import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import * as Icon from 'react-icons/md';
// import 'react-pro-sidebar/dist/css/styles.css';
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { signOut } from '../../../reducers/authSlice';
import '../../defaultLayout/DefaultLayout.scss';

const SlideBar = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();

    const onLogout = () => {
        dispatch(signOut());
    }

    return (
        <Sidebar>
            <Menu>
                <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '40px', padding: "30px 0px" }}>
                    Monea
                </div>
                <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem
                        icon={<Icon.MdDashboard />}
                        className={location.pathname === "/" ? "active" : ""}
                    >
                        Dashboard
                    </MenuItem>
                </Link>
                <Link to="/iap" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem
                        icon={<Icon.MdShoppingCart />}
                        className={location.pathname === "/iap" ? "active" : ""}
                    >
                        In app purchase
                    </MenuItem>
                </Link>
                <Link to="/ads" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem
                        icon={<Icon.MdAdsClick />}
                        className={location.pathname === "/ads" ? "active" : ""}
                    >
                        Google Ads Mob
                    </MenuItem>
                </Link>
                <Link to="/default-category" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem
                        icon={<Icon.MdCategory />}
                        className={location.pathname === "/default-category" ? "active" : ""}
                    >
                        Default Category
                    </MenuItem>
                </Link>
                <Link to="/category" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem
                        icon={<Icon.MdLabel />}
                        className={location.pathname === "/category" ? "active" : ""}
                    >
                        Category
                    </MenuItem>
                </Link>
                <Link to="/exepense" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem
                        icon={<Icon.MdAttachMoney />}
                        className={location.pathname === "/exepense" ? "active" : ""}
                    >
                        Exepense
                    </MenuItem>
                </Link>
                <Link to="/account" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem
                        icon={<Icon.MdPeople />}
                        className={location.pathname === "/account" ? "active" : ""}
                    >
                        Account
                    </MenuItem>
                </Link>
                <Link to="/reports" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <MenuItem
                        icon={<Icon.MdFeedback />}
                        className={location.pathname === "/reports" ? "active" : ""}
                    >
                        Reports & Feedback
                    </MenuItem>
                </Link>
                <MenuItem icon={<Icon.MdLogout />} onClick={onLogout}>
                    Logout
                </MenuItem>
            </Menu>
        </Sidebar>
    )
}

export default SlideBar;
